import React from 'react';
import PropTypes from 'prop-types';
import { FilterSelector } from './FilterSelector';
import { useSearchStore } from '../../../store/search/store';
import { terms, showOptions } from '../../constants/savedAgents';
import { filterIds, searchfilterStateId as sfState, viewOptionsByTab } from '../../constants/suggestedAgents';

export const Display = ({togglePopover}) => {

    const {
        selectedView,
        selectedAgentsView,
        setSearchFilterState,
        currentTabId,
    } = useSearchStore(state => {
        const { [state.selectedModule] : moduleState } = state;
        const { currentTabId } = moduleState
        const { [currentTabId]: tabState } = moduleState?.searchOptions;
        return {
            selectedView: tabState?.display?.selectedView,
            selectedAgentsView: tabState?.display?.selectedAgentsView,
            setSearchFilterState: state.setSearchFilterState,
            currentTabId,
        }
    });

    const viewOptions = viewOptionsByTab[currentTabId];

    const handleViewChange = (option, filterId, stateId) => {
        const selectedView = viewOptions.find(view => view.value === option.value)
            || showOptions.find(view => view.value === option.value);
        setSearchFilterState(selectedView, filterId, stateId);
        togglePopover();
    };

    return (
        <div className='py-2' dataLwtId='suggested-agents-display-dropdown'>
            <FilterSelector
                dataLwtId='select-agents-view'
                defaultValue={selectedView}
                labelText={terms.view}
                options={viewOptions}
                onChange={(option) => handleViewChange(option, filterIds.display, sfState.selectedView)}
            />
            <FilterSelector
                dataLwtId='select-agents-groups'
                defaultValue={selectedAgentsView}
                labelText={terms.agents}
                options={showOptions}
                onChange={(option) => handleViewChange(option, filterIds.display, sfState.selectedAgentsView)}
            />
        </div>
    )
};

Display.propTypes = {
    togglePopover: PropTypes.func.isRequired,
};
